import { render, staticRenderFns } from "./ProductLinecurrent.vue?vue&type=template&id=74b04583&scoped=true&"
import script from "./ProductLinecurrent.vue?vue&type=script&lang=js&"
export * from "./ProductLinecurrent.vue?vue&type=script&lang=js&"
import style0 from "./ProductLinecurrent.vue?vue&type=style&index=0&id=74b04583&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b04583",
  null
  
)

export default component.exports